import { FC } from 'react';
import { Item, StyledLink } from './ListItem.styled';
import { ListItemProps } from '../../../../../../@types/header.types';

export const ListItem: FC<ListItemProps> = ({ page, title }) => {
  return (
    <Item>
      <StyledLink to={page}>{title}</StyledLink>
    </Item>
  );
};
